import React from "react";
import { Navigate, Route, Outlet as RouterOutlet, Routes } from "react-router-dom";
import DigitalMarketing from "./digital-marketing/DigitalMarketing";
import ProjectDevelopment from "./project-development/ProjectDevelopment";
import DesignDevelopment from "./project-development/design-development/DesignDevelopment";
import QATesting from "./project-development/qa-testing/QATesting";
import MobileAppDevelopment from "./project-development/Mobile-App-Development/MobileAppDevelopment";
import WebDevelopment from "./project-development/web-development/WebDevelopment";
import EnterpriseApplication from "./project-development/enterprise-application/EnterpriseApplication";
import StaffAugmentation from "./staff-augmentation/StaffAugmentation";

const ServicesRoutes = () => {
   return (
      <Routes>
         <Route element={<RouterOutlet />}>
            <Route path="digital-marketing" element={<DigitalMarketing />} />
            <Route path="project-development" element={<RouterOutlet />}>
               <Route index element={<ProjectDevelopment />} />
               <Route path="design_development" element={<DesignDevelopment />} />
               <Route path="qa_testing" element={<QATesting />} />
               <Route path="mobile_app" element={<MobileAppDevelopment />} />
               <Route path="web_app" element={<WebDevelopment />} />
               <Route path="enterprise_app" element={<EnterpriseApplication />} />
            </Route>
            <Route path="staff_augmentation" element={<StaffAugmentation />} />
         </Route>
         <Route path="*" element={<Navigate to="project-development" replace />} />
      </Routes>
   );
};
export default function ServicesModule() {
   return (
      <>
         <ServicesRoutes />
      </>
   );
}
